import axios from "./axios";

export interface AccessUiMessageRecord {
  id?: string;
  reason: string;
  title: string;
  message: string;
  primaryCtaLabel?: string | null;
  primaryCtaUrl?: string | null;
  secondaryCtaLabel?: string | null;
  secondaryCtaUrl?: string | null;
  showSingleUnlock: boolean;
  showPackages: boolean;
  showLoginPrompt: boolean;
  updatedAtUtc?: string;
}

export async function getAdminAccessUiMessages(): Promise<AccessUiMessageRecord[]> {
  try {
    const res = await axios.get("/admin/access-ui");
    const payload = Array.isArray(res.data) ? res.data : [];
    return payload.map(normalizeRecord);
  } catch (error) {
    console.error("getAdminAccessUiMessages error", error);
    return [];
  }
}

export async function upsertAdminAccessUiMessage(payload: AccessUiMessageRecord): Promise<{ success: boolean }> {
  try {
    const res = await axios.post("/admin/access-ui", payload);
    return { success: Boolean(res.data?.success ?? true) };
  } catch (error) {
    console.error("upsertAdminAccessUiMessage error", error);
    return { success: false };
  }
}

export async function deleteAdminAccessUiMessage(reason: string): Promise<{ success: boolean }> {
  try {
    const res = await axios.delete(`/admin/access-ui/${encodeURIComponent(reason)}`);
    return { success: Boolean(res.data?.success ?? true) };
  } catch (error) {
    console.error("deleteAdminAccessUiMessage error", error);
    return { success: false };
  }
}

function normalizeRecord(raw: any): AccessUiMessageRecord {
  return {
    id: raw?.id ?? raw?.Id ?? undefined,
    reason: (raw?.reason ?? raw?.Reason ?? "generic").toString(),
    title: (raw?.title ?? raw?.Title ?? "Bölüm kilitli").toString(),
    message: (raw?.message ?? raw?.Message ?? "Bu bölüm şu anda okunamıyor.").toString(),
    primaryCtaLabel: raw?.primaryCtaLabel ?? raw?.PrimaryCtaLabel ?? null,
    primaryCtaUrl: raw?.primaryCtaUrl ?? raw?.PrimaryCtaUrl ?? null,
    secondaryCtaLabel: raw?.secondaryCtaLabel ?? raw?.SecondaryCtaLabel ?? null,
    secondaryCtaUrl: raw?.secondaryCtaUrl ?? raw?.SecondaryCtaUrl ?? null,
    showSingleUnlock: Boolean(raw?.showSingleUnlock ?? raw?.ShowSingleUnlock ?? false),
    showPackages: Boolean(raw?.showPackages ?? raw?.ShowPackages ?? false),
    showLoginPrompt: Boolean(raw?.showLoginPrompt ?? raw?.ShowLoginPrompt ?? false),
    updatedAtUtc: raw?.updatedAtUtc ?? raw?.UpdatedAtUtc ?? undefined,
  };
}
